import "./IconButton.css";
import React from "react";
import classNames from "classnames";
import { Tooltip } from "react-bootstrap";

type Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "submit" | "reset" | "button";
  className?: string;
  children?: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
  /** Tooltip nativo del browser (attributo `title`) e etichetta accessibile. */
  title?: string;
};

export default function IconButton({
  disabled,
  type,
  onClick,
  className,
  children,
  tooltip,
  title,
}: Props) {
  return tooltip ? (
    <Tooltip title={tooltip}>
      <button
        onClick={onClick}
        type={type}
        disabled={disabled}
        title={title}
        aria-label={title}
        className={classNames(["icon-button", className])}
      >
        {children}
      </button>
    </Tooltip>
  ) : (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      title={title}
      aria-label={title}
      className={classNames(["icon-button", className])}
    >
      {children}
    </button>
  );
}
